import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../../../app/store";
import { anomalie } from "./anomalieTypes";

const initialState: anomalie = {
  selectedTab: "generalGrid",
  selectedTabVorher: "generalGrid",
};

const anomalieSlice = createSlice({
  name: "anomalie",
  initialState,
  reducers: {
    // Setters

    setSelectedTab: (state, action: PayloadAction<string>) => {
      state.selectedTab = action.payload;
    },
    setSelectedTabVorher: (state, action: PayloadAction<string>) => {
      state.selectedTabVorher = action.payload;
    },
  },
});

// Selectors
export const selectSelectedTab = (state: RootState): string =>
  state.anomalie.selectedTab;
export const selectSelectedTabVorher = (state: RootState): string =>
  state.anomalie.selectedTabVorher;

// Actions

export const { setSelectedTab, setSelectedTabVorher } = anomalieSlice.actions;

export default anomalieSlice.reducer;
